import { FaGithub } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";
import "./home.css";

const Home = () => {
  const senderEmail = "alifhakimiazwan@gmail.com";

  const handleComposeEmail = () => {
    const mailtoLink = `mailto:${senderEmail}`;
    window.open(mailtoLink, "_blank");
  };

  return (
    <div className="mt-6 sm:mt-8 md:mt-12 px-4 sm:px-6 md:px-0">
      <div className="flex flex-col items-center">
        <div className="relative text-black items-start rounded-full bg-white shadow-lg shadow-sky-500">
          <div className="absolute rounded-full -inset-0 bg-gradient-to-r from-purple-600 to-pink-600 blur z-5"></div>
          <img
            src="assets/profile_pic.jpeg"
            className="relative z-10 w-40 h-40 sm:w-48 sm:h-48 md:w-56 md:h-56 lg:w-60 lg:h-60 rounded-full object-cover border-4 border-black"
          />
        </div>
        <div className="flex flex-row items-center text-center text-3xl sm:text-4xl md:text-5xl mt-6 sm:mt-8 md:mt-12 animate-appear1">
          <span className="ml-2 sm:ml-3">Alif</span>
          <span className="ml-2 sm:ml-3">Hakimi</span>
        </div>
        <div className="flex flex-row items-center text-center text-xl sm:text-2xl md:text-3xl mt-2 sm:mt-3 md:mt-4 animate-appear2">
          <span className="ml-2 sm:ml-3">Backend</span>
          <span className="ml-2 sm:ml-3">Engineer</span>
        </div>
        <ul className="bg-gray-100 flex items-center justify-center p-1 rounded-3xl shadow-sm mt-5 sm:mt-6 md:mt-7">
          <a
            className="p-2 sm:p-3"
            target="_blank"
            href="https://github.com/alifhakimiazwan"
          >
            <FaGithub className="text-lg sm:text-xl opacity-50 transition-opacity duration-200 ease-in-out hover:opacity-100" />
          </a>
          <a
            className="p-2 sm:p-3"
            target="_blank"
            href="https://www.linkedin.com/in/alif-hakimi-azwan/"
          >
            <FaLinkedin className="text-lg sm:text-xl opacity-50 transition-opacity duration-200 ease-in-out hover:opacity-100" />
          </a>
        </ul>
        <div className="relative z-10 text-black flex flex-col items-start rounded-xl w-auto bg-white r shadow-lg shadow-sky-500 mt-6 sm:mt-8 md:mt-10">
          <div className="absolute -inset-1 bg-gradient-to-r from-purple-600 to-pink-600 rounded-xl blur opacity-25 group-hover:opacity-100 transition duration-1000 group-hover:duration-200"></div>
          <button
            onClick={handleComposeEmail}
            className="relative gradient-border rounded-xl flex items-center justify-center bg-black hover:bg-white hover:text-black opacity-95 hover:opacity-100 text-white px-4 py-2 sm:px-6 sm:py-3 md:px-10 md:py-6 text-base sm:text-lg md:text-xl transform hover:scale-105 duration-300 whitespace-nowrap"
          >
            Send me an email
          </button>
        </div>
      </div>
    </div>
  );
};

export default Home;
